import React, {useState} from 'react';
import {IconButton, Drawer, List, ListItem, ListItemText} from "@mui/material";
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import './HeaderDrawer.sass'
import {NavLink} from "./Header";

function HeaderDrawer() {
    const [openDrawer, setOpenDrawer] = useState(false)

    return (
        <>
            <IconButton onClick={() => setOpenDrawer(!openDrawer)} sx={{color: 'inherit'}}>
                <MenuIcon fontSize={'large'} />
            </IconButton>

            <Drawer
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                disableScrollLock={true}
                anchor={'right'}
            >
                <List>
                  <ListItem onClick={() => setOpenDrawer(false)}>
                    <ListItemText>
                        <NavLink to={'/#'} className={'header_drawer__nav__item'}>
                            home
                        </NavLink>
                    </ListItemText>
                  </ListItem>
                  <ListItem onClick={() => setOpenDrawer(false)}>
                    <ListItemText>
                        <NavLink to={'/#about'} className={'header_drawer__nav__item'}>
                            about
                        </NavLink>
                    </ListItemText>
                  </ListItem>
                  <ListItem onClick={() => setOpenDrawer(false)}>
                    <ListItemText>
                        <NavLink to={'/#work'} className={'header_drawer__nav__item'}>
                            work
                        </NavLink>
                    </ListItemText>
                  </ListItem>
                  <ListItem onClick={() => setOpenDrawer(false)}>
                    <ListItemText>
                        <NavLink to={'/#contact'} className={'header_drawer__nav__item'}>
                            contact
                        </NavLink>
                    </ListItemText>
                  </ListItem>
                </List>

                <Divider />

                <List>
                  <ListItem onClick={() => setOpenDrawer(false)}>
                    <ListItemText>
                        <NavLink to={'/more'} className={'header_drawer__nav__item header_drawer__nav__item_less'}>
                            more about me
                        </NavLink>
                    </ListItemText>
                  </ListItem>
                  <ListItem onClick={() => setOpenDrawer(false)}>
                    <ListItemText>
                        <NavLink to={'/work'} className={'header_drawer__nav__item header_drawer__nav__item_less'}>
                            more work
                        </NavLink>
                    </ListItemText>
                  </ListItem>
                  <ListItem onClick={() => setOpenDrawer(false)}>
                    <ListItemText>
                        <a
                            href={'https://drive.google.com/file/d/1_TtgR3HEABau-rBxm2rdvUe7dTN5yFeT/view'}
                            className={'header_drawer__nav__item header_drawer__nav__item_less'}
                        >
                            resume
                        </a>
                    </ListItemText>
                  </ListItem>
                </List>
              </Drawer>
        </>
    );
}

export default HeaderDrawer;